var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.appConfig),function(project){return _c('router-link',{key:project.projectName,attrs:{"to":{ name: ("project-" + (project.projectName)) }}},[_c('BButton',[_vm._v(_vm._s(project.title))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }